import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { CircularProgress } from '@mui/material';
import { permit } from '@lba-dev/package.local-globals/restrictions';
import { S_SATCL } from '@lba-dev/package.local-globals/services';

import MinCustomDialog from './MinCustomDialog';
import notifSystem from '../../notifSystem';
import api from '../../api';


const mapStateToProps = ({ connectedUser, users }) => ({
  user: connectedUser,
  users,
});

class DialogSupport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
      step: 0,
      loading: true,
      remaining: 0,
      cap: 0,
      isAdmin: false,
      isUserInSatCl: false,
      creditsUnlocked: 0,
      comments: ((props.defaultText || {}).data || []).reverse(),
    };
  }

  setTextValue = (e) => {
    this.setState({
      value: e.target.value,
    });
  };

  onValidate = () => {
    if (typeof this.props.callback === 'function') {
      this.props.callback(this.state.value);
    }
  };
  onReject = (value) => {
    if (typeof this.props.callback === 'function') {
      this.props.callback(value);
    }
  };

  componentDidMount() {
    this.getCounter();
  }

  getPermission = () => {
    const { user } = this.props;
    const isAdmin = permit(user);
    const isUserInSatCl = user?.service === S_SATCL;
    return { isAdmin, isUserInSatCl };
  }

  getCounter = async () => {
    try {
      const result = await api.interventions
        .custom('supportCredits')
        .get()
        .then(e => e.body().data());

      let step = 1;
      const { isAdmin, isUserInSatCl } = this.getPermission();
      if (!result.permission && !isAdmin && !isUserInSatCl) {
        step = result.creditsUnlocked === 0 ? 3 : 2;
      }

      this.setState({
        step,
        isAdmin,
        isUserInSatCl,
        remaining: result.remaining || 0,
        cap: result.cap || 0,
        creditsUnlocked: result.creditsUnlocked || 0,
      });
    } catch (error) {
      notifSystem.error('Erreur', 'Une erreur est survenue.');
    }
  }

  steps = {
    0: {
      actions: [
        {
          title: 'Annuler',
          onClick: () => this.onReject(null),
          color: 'secondary',
        },
      ],
      title: 'Chargement en cours...',
      Component: () => <CircularProgress size={70} color="secondary" />
    },
    1: {
      actions: [
        {
          title: 'Annuler',
          onClick: () => this.onReject(null),
          color: 'secondary',
        },
        {
          title: 'Non',
          onClick: () => this.onReject(true),
          color: 'secondary',
        },
        {
          title: 'Valider',
          onClick: () =>
            !this.state.value
              ? notifSystem.error('Erreur', 'Veuillez saisir un texte.')
              : this.onValidate(),
          color: 'primary',
        },
      ],
      title: 'Y a t-il précision à apporter a votre intervention ?',
      Component: () => {
        const {
          cap, remaining, creditsUnlocked, isAdmin, isUserInSatCl
        } = this.state;
        const getMsg = () => {
          if (isAdmin) {
            return 'Vous êtes administrateur';
          }
          if (isUserInSatCl) {
            return 'Vous êtes dans le service Satisfaction client';
          }
          return `Il vous reste ${remaining} crédit(s) support
           (${creditsUnlocked}/${cap} débloqués)`;
        };
        return [
          isAdmin || isUserInSatCl ?
            <Typography
              key="0"
              variant="subtitle1"
              children={`${getMsg()}, vous n'avez pas de limite de crédit.`}
            /> :
            <Typography
              key="1"
              variant="subtitle1"
              children={getMsg()}
            />,
          <TextField
            variant="standard"
            key="2"
            fullWidth
            onChange={this.setTextValue}
            value={this.state.value}
            multiline={true}
            maxRows={10}
          />,
        ];
      }
    },
    2: {
      actions: [
        {
          title: 'OK',
          onClick: () => this.onReject(null),
          color: 'secondary',
        },
      ],
      title: 'Message',
      Component: () =>
        'Vous avez atteint votre limite de crédit pour aujourd\'hui.',
    },
    3: {
      actions: [
        {
          title: 'OK',
          onClick: () => this.onReject(null),
          color: 'secondary',
        },
      ],
      title: 'Message',
      Component: () =>
        'Vous n\'avez pas encore débloqué de crédits support. '
        + 'Continuez vos interventions pour en débloquer !',
    },
  };

  render() {
    const { step: stateStep } = this.state;
    const { Component, title, actions } = this.steps[stateStep];
    return (
      <MinCustomDialog
        middle
        open
        title={title}
        actions={actions.map(({ title, onClick, color }) => (
          <Button key={title} onClick={onClick} color={color}>
            {title}
          </Button>
        ))}
      >
        {
          Component &&
          <Component />
        }
      </MinCustomDialog>
    );
  }
}

DialogSupport.propTypes = {
  callback: PropTypes.func.isRequired,
  defaultText: PropTypes.object,
};

export default connect(mapStateToProps)(DialogSupport);
